export const updateReviewMutation = `
mutation updateStorefrontReview(
  $reviewId: ID!
  $content: String
  $ratings: [EditReviewRatingInput!]
  $photos: [CreateOrEditReviewPhotoInput!]
  $attributes: EditReviewAttributesInput!,
  $firstName: String,
  $lastName: String
) {
  editReview(
    input: {
      reviewId: $reviewId
      content: $content
      ratings: $ratings
      photos: $photos
      attributes: $attributes,
      firstName: $firstName,
      lastName: $lastName
    }
  ) {
    review {
     id
    }
  }
}
`;

export interface UpdateStorefrontReviewVariables {
	reviewId: string;
	content: string;
	ratings: EditReviewRatingInput[];
	photos: CreateOrEditReviewPhotoInput[];
	attributes: EditReviewAttributesInput;
	firstName?: string;
	lastName?: string;
}

export interface EditReviewRatingInput {
	ratingId: string;
	value: number;
}

export interface CreateOrEditReviewPhotoInput {
	sortOrder: number;
	sourceId: string;
	height: number | null;
	width: number | null;
}

export interface EditReviewAttributesInput {
	budgetCost?: number;
	budgetGuestCount?: number;
}

export interface EditReviewResponse {
	editReview: {
		review: {
			id: string;
		};
	};
}
